import { useAuth } from "@mindlercare/auth-ui";
import { ReactNode } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getRoles } from "../helpers/roles";
import { usePsychologistUser } from "hooks";

export const RequiresProfileSetup: React.FC = ({
  children,
}: {
  children?: ReactNode;
}) => {
  const { roles: userRoles } = useAuth();
  const roles = getRoles(userRoles);

  const { psychologist, isLoading } = usePsychologistUser();
  if (
    roles.isPsychologist &&
    !isLoading &&
    (!psychologist?.psychologistId || psychologist?.thumbnail === null) // Force profile page for psychologists that have not completed it
  ) {
    return <Navigate to="/profile" replace />;
  }

  return <>{children ?? <Outlet />}</>;
};
